import useWarningsTolerance from 'hooks/useWarningsTolerance'
import { getDurationWarnings } from '../RotaDrawer/components/DrawerStatus/utils'
import { ClockInTeamMember } from 'screens/Rostering/types'
import { useMemo } from 'react'

const useDurationWarnings = (warnings: ClockInTeamMember['warnings']) => {
  const warningsTolerance = useWarningsTolerance()

  const durationWarnings = useMemo(
    () => getDurationWarnings(warnings, warningsTolerance),
    [warnings]
  )

  return durationWarnings
}

export default useDurationWarnings
